<template>
    <div class="about">
        about
    </div>
</template>
<script>

export default {
    name: 'About',
    components: {}
};
</script>

<style scoped>

</style>
